import styles from './icon.module.css'

export const getClassSize = size => {
  if (size === 'big') {
    return styles.iconBig
  }

  if (size === 'medium') {
    return styles.iconMedium
  }

  if (size === 'small') {
    return styles.iconSmall
  }

  return styles.icon
}

export const getClassColor = color => {
  if (color === 'white') {
    return styles.pathWhite
  }

  if (color === 'primary') {
    return styles.pathPrimary
  }

  return styles.path
}
